import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import ServiceButtonWithToast from '../../../_common/ServiceButtonWithToast';
import { useApiClient } from '../../../../context/ApiClientContext';

function AnchorMedsSectionInReportForm(props) {
  const { actionListId, onSuccess } = props;

  const apiClient = useApiClient();

  const handleButtonClick = () => apiClient.anchorMedsSectionInReport(actionListId);

  return (
    <>
      <Typography sx={{ marginBottom: '10px' }}>
        Please confirm you want to anchor the medications section in the report here.
        Note that if there are multiple anchors in an intake, only the first one will be used.
      </Typography>
      <ServiceButtonWithToast
        service={handleButtonClick}
        onSuccess={onSuccess}
        buttonText="Confirm"
        successMsg="Success"
      />
    </>
  );
}

AnchorMedsSectionInReportForm.propTypes = {
  actionListId: PropTypes.number.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default AnchorMedsSectionInReportForm;
